import { StandingsFilter } from '../../../model/interfaces';

const standingsTableColumns: { title: string; filter?: StandingsFilter }[] = [
  {
    title: 'rank',
    filter: 'rank',
  },
  {
    title: 'best_rank',
  },
  {
    title: 'games',
    filter: 'ngames',
  },
  {
    title: 'wins',
    filter: 'wins',
  },
  {
    title: 'win_percent',
    filter: 'win_pc',
  },
  {
    title: 'streak',
  },
  {
    title: 'best_streak',
    filter: 'streak',
  },
  {
    title: 'month_won_lost',
  },
  {
    title: 'n_tourneys_won',
    filter: 'ntrnwon',
  },
  {
    title: 'n_tourney_games',
  },
  {
    title: 'n_tourney_games_won',
    filter: 'nwontrngames',
  },
  {
    title: 'idle_days',
  },
];

export default standingsTableColumns;
